import { TorchApplicationProvider } from '../components/TorchApplicationContext'
import { TorchApplicationPages } from '../pages/TorchApplicationPages'

export const CreateTorch = () => {
  return (
    <div className="flex w-full flex-col items-center gap-8 bg-white pb-10 pt-24 lg:gap-20 lg:py-20 lg:pb-60">
      <TorchApplicationProvider>
        <TorchApplicationPages />
      </TorchApplicationProvider>
    </div>
  )
}
